import { Car, Fuel, Radio, Monitor, Building2, CreditCard } from "lucide-react";

export const TABS = [
  { key: "vehicules", label: "Vehicules", icon: Car },
  { key: "carburant", label: "Carte carburant", icon: Fuel },
  { key: "telepeage", label: "Telepeage", icon: Radio },
  { key: "equipements", label: "Equipements IT", icon: Monitor },
  { key: "locaux", label: "Locaux", icon: Building2 },
  { key: "paiements", label: "Paiements", icon: CreditCard },
];

export const STATUT_OPTIONS = ["actif", "inactif", "en_maintenance", "vendu", "expire"];
export const STATUT_COLORS = {
  actif: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  inactif: "bg-slate-500/15 text-slate-400 border-slate-500/20",
  en_maintenance: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  vendu: "bg-red-500/15 text-red-400 border-red-500/20",
  expire: "bg-red-500/15 text-red-400 border-red-500/20",
};
export const STATUT_LABELS = { actif: "Actif", inactif: "Inactif", en_maintenance: "En maintenance", vendu: "Vendu", expire: "Expire" };

export const INSPECTION_STATUT = {
  conforme: { label: "Conforme", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20" },
  non_conforme: { label: "Non conforme", cls: "bg-red-500/15 text-red-400 border-red-500/20" },
  a_planifier: { label: "A planifier", cls: "bg-amber-500/15 text-amber-400 border-amber-500/20" },
  en_cours: { label: "En cours", cls: "bg-blue-500/15 text-blue-400 border-blue-500/20" },
};

export const FREQUENCE_OPTIONS = [
  { value: "mensuelle", label: "Mensuelle" }, { value: "trimestrielle", label: "Trimestrielle" },
  { value: "semestrielle", label: "Semestrielle" }, { value: "annuelle", label: "Annuelle" },
  { value: "biennale", label: "Tous les 2 ans" },
];

export const CARD_BRANDS = {
  "CB Visa": { color: "#1a1f71", accent: "#f7b600", label: "VISA" },
  "CB Mastercard": { color: "#eb001b", accent: "#f79e1b", label: "MC" },
  "Virtuelle Visa": { color: "#1a1f71", accent: "#00bcd4", label: "V.VISA" },
  "Virtuelle Mastercard": { color: "#eb001b", accent: "#00bcd4", label: "V.MC" },
  "Virement": { color: "#2563eb", accent: "#2563eb", label: "VIR" },
  "Prelevement": { color: "#7c3aed", accent: "#7c3aed", label: "PRLV" },
  "Cheque": { color: "#059669", accent: "#059669", label: "CHQ" },
  "Especes": { color: "#d97706", accent: "#d97706", label: "ESP" },
  "PayPal": { color: "#003087", accent: "#009cde", label: "PP" },
  "Autre": { color: "#6b7280", accent: "#6b7280", label: "?" },
};

export const CARBURANT_FOURNISSEURS = ["Total Energies", "Shell", "Esso", "BP", "DKV", "UTA", "Routex", "Edenred", "Ticket Car", "Autre"];
export const TELEPEAGE_FOURNISSEURS = ["Vinci Autoroutes", "APRR", "Sanef", "Bip&Go", "Ulys", "Autre"];

export const FIELDS = {
  vehicules: [
    { key: "societe", label: "Societe", type: "text" },
    { key: "marque", label: "Marque", type: "text", required: true },
    { key: "modele", label: "Modele", type: "text", required: true },
    { key: "immatriculation", label: "Immatriculation", type: "text", required: true },
    { key: "type_vehicule", label: "Type", type: "select", options: ["Voiture", "Utilitaire", "Camion", "Moto", "Autre"] },
    { key: "couleur", label: "Couleur", type: "text" },
    { key: "km", label: "Kilometrage", type: "number" },
    { key: "date_ct", label: "Date CT", type: "date" },
    { key: "assurance", label: "Assureur", type: "text" },
    { key: "date_assurance", label: "Echeance assurance", type: "date" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  paiements: [
    { key: "societe", label: "Societe", type: "text" },
    { key: "type_paiement", label: "Type", type: "select", options: ["CB Visa", "CB Mastercard", "Virtuelle Visa", "Virtuelle Mastercard", "Virement", "Prelevement", "Cheque", "Especes", "PayPal", "Autre"], required: true },
    { key: "titulaire", label: "Titulaire", type: "text", required: true },
    { key: "banque", label: "Banque", type: "text" },
    { key: "iban", label: "IBAN", type: "text" },
    { key: "numero", label: "Numero (4 derniers)", type: "text" },
    { key: "pin", label: "Code PIN", type: "pin" },
    { key: "date_expiration", label: "Date expiration", type: "text", placeholder: "MM/AA" },
    { key: "plafond", label: "Plafond (EUR)", type: "number" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  carburant: [
    { key: "societe", label: "Societe", type: "text" },
    { key: "fournisseur", label: "Fournisseur", type: "select", options: CARBURANT_FOURNISSEURS, required: true },
    { key: "numero_carte", label: "Numero de carte", type: "text", required: true },
    { key: "vehicule_id", label: "Vehicule affecte", type: "vehicule_select" },
    { key: "personne_affectee", label: "Personne affectee", type: "personne_select" },
    { key: "plafond", label: "Plafond (EUR)", type: "number" },
    { key: "date_expiration", label: "Date expiration", type: "date" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  telepeage: [
    { key: "societe", label: "Societe", type: "text" },
    { key: "fournisseur", label: "Fournisseur", type: "select", options: TELEPEAGE_FOURNISSEURS, required: true },
    { key: "numero_badge", label: "Numero de badge", type: "text", required: true },
    { key: "vehicule_id", label: "Vehicule affecte", type: "vehicule_select" },
    { key: "personne_affectee", label: "Personne affectee", type: "personne_select" },
    { key: "formule", label: "Formule / Abonnement", type: "text" },
    { key: "date_expiration", label: "Date expiration", type: "date" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  equipements: [
    { key: "type_equipement", label: "Type", type: "select", options: ["Ordinateur portable", "Ordinateur fixe", "Ecran", "Imprimante", "Telephone", "Tablette", "Serveur", "Routeur", "Autre"], required: true },
    { key: "marque", label: "Marque", type: "text", required: true },
    { key: "modele", label: "Modele", type: "text" },
    { key: "numero_serie", label: "N de serie", type: "text" },
    { key: "attribue_a", label: "Attribue a", type: "text" },
    { key: "date_achat", label: "Date d'achat", type: "date" },
    { key: "garantie_fin", label: "Fin de garantie", type: "date" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  locaux: [
    { key: "nom", label: "Nom / Designation", type: "text", required: true },
    { key: "adresse", label: "Adresse", type: "text", required: true },
    { key: "type_bail", label: "Type de bail", type: "select", options: ["Commercial", "Professionnel", "Mixte", "Propriete", "Autre"] },
    { key: "surface_m2", label: "Surface (m2)", type: "number" },
    { key: "loyer_mensuel", label: "Loyer mensuel (EUR)", type: "number" },
    { key: "capacite", label: "Capacite (personnes)", type: "number" },
    { key: "date_bail", label: "Date de bail", type: "date" },
    { key: "statut", label: "Statut", type: "statut" },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
};

export const TABLE_COLS = {
  vehicules: ["societe", "marque", "modele", "immatriculation", "type_vehicule", "km", "statut"],
  paiements: ["type_paiement", "societe", "titulaire", "banque", "numero", "statut"],
  carburant: ["fournisseur", "numero_carte", "societe", "vehicule_label", "personne_affectee", "statut"],
  telepeage: ["fournisseur", "numero_badge", "societe", "vehicule_label", "personne_affectee", "statut"],
  equipements: ["type_equipement", "marque", "modele", "attribue_a", "statut"],
  locaux: ["nom", "adresse", "surface_m2", "loyer_mensuel", "statut"],
};

export const COL_LABELS = {
  marque: "Marque", modele: "Modele", immatriculation: "Immat.", type_vehicule: "Type",
  km: "Km", statut: "Statut", type_paiement: "Type", titulaire: "Titulaire",
  banque: "Banque", numero: "N carte", type_equipement: "Type",
  attribue_a: "Attribue a", nom: "Nom", adresse: "Adresse",
  surface_m2: "Surface m2", loyer_mensuel: "Loyer EUR", societe: "Societe",
  fournisseur: "Fournisseur", numero_carte: "N carte", numero_badge: "N badge",
  vehicule_label: "Vehicule", personne_affectee: "Personne", formule: "Formule",
};

export const FILTER_TYPE_OPTIONS = {
  vehicules: ["Voiture", "Utilitaire", "Camion", "Moto", "Autre"],
  paiements: ["CB Visa", "CB Mastercard", "Virtuelle Visa", "Virtuelle Mastercard", "Virement", "Prelevement", "Cheque", "Especes", "PayPal", "Autre"],
  equipements: ["Ordinateur portable", "Ordinateur fixe", "Ecran", "Imprimante", "Telephone", "Tablette", "Serveur", "Routeur", "Autre"],
  locaux: ["Commercial", "Professionnel", "Mixte", "Propriete", "Autre"],
  carburant: CARBURANT_FOURNISSEURS,
  telepeage: TELEPEAGE_FOURNISSEURS,
};
